import { labelTpl } from './label';
import { labelAlertTpl } from './alert';
import { labelLinkTpl } from './link';

export {
    labelTpl,
    labelAlertTpl,
    labelLinkTpl
}